import { IState } from 'legacy/lut/store'

export const selectPartnerFiles = (state: IState) => state.partner.partnerFiles
